import Controller from "./promotions.controller";
import template from "./promotions.html";

const promotions = {
  template,
  controller: Controller,
};

export default promotions;



// WEBPACK FOOTER //
// ./src/pages/promotions/promotions.component.js